import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import ClickUpIntegrationHelmet from 'common/helmets/ClickUpIntegrationHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';
import ClickUp1 from 'img/landing/clickup-integration-1.webp';
import ClickUp2 from 'img/landing/clickup-integration-2.webp';
import ClickUp3 from 'img/landing/clickup-integration-3.webp';

import ClickUpLogo from 'img/canny-clickup-integration.png';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class ClickUpLanding extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed ClickUp Integration Page');
  }

  render() {
    return (
      <div className="integrationsLanding">
        <ClickUpIntegrationHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage className="appLogo" loading="eager" src={ClickUpLogo} />
              <div className="text">
                <h1 className="title">Canny for ClickUp</h1>
                <div className="subtitle">Sync feedback between Canny and&nbsp;ClickUp</div>
                <div className="links">
                  <InstallExtensionButton
                    installButtonText="Install ClickUp"
                    installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fclickup"
                  />
                  <a
                    href="https://help.canny.io/en/articles/5598154-clickup-integration"
                    rel="noopener"
                    target="_blank"
                    className="LandingIntegrations__install-link">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={ClickUp1} />
              </div>
              <div className="featureText">
                <div className="title">Link Canny posts with ClickUp&nbsp;Tasks</div>
                <div className="subtitle">
                  Push tasks from Canny to ClickUp and link between the&nbsp;two.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={ClickUp2} />
              </div>
              <div className="featureText">
                <div className="title">Push posts to&nbsp;ClickUp</div>
                <div className="subtitle">
                  See a great idea in Canny? Push it over to ClickUp as a task and automatically
                  link them&nbsp;together.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={ClickUp3} />
              </div>
              <div className="featureText">
                <div className="title">Keep statuses in&nbsp;sync</div>
                <div className="subtitle">
                  No more worrying about losing track of status updates. Create rules to
                  automatically sync statuses between ClickUp and&nbsp;Canny.
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default compose(
  withContexts({
    trackEvent: TrackEventContext,
    viewer: ViewerContext,
  }),
  hot,
)(ClickUpLanding);
